// JavaScript Document
//components/core/DeleteButton.js
import React from 'react';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';



export default function DeleteButton(props) {
	//inherited variables
  	const {onClick, visible} = props;
	const [delState, setDelState] = React.useState(0);
	const delConfirmations = [
		'Delete',
		'Really Delete?',
		'Permanently?',
		'This cannot be undone',
		'Are you sure?',
		'Last chance!'
	];


	
	//Handle clicking delete button
	const deleteClick = (e) => {
		var curDel = delState + 1;
		//have they confirmed them all?
		if(delConfirmations.length === curDel){
			//final confirmation
			if(onClick)
				onClick(e);
			setDelState(0);
		} else {
			setDelState(curDel);
		}
	}
	
	//render the delete button
	if(visible){
		return (
			<Button
				 	variant="contained"
				 	color="secondary"
				 	onClick={deleteClick}
					endIcon={<DeleteIcon />}
				>{delConfirmations[delState]}</Button>
		);
	}
	return '';
}
